<script setup lang="ts">
import { BaseSkeleton } from '@/shared/ui/BaseSkeleton';
import { FlowCard } from '@/shared/ui/FlowCard';
</script>

<template>
  <FlowCard controls-off>
    <BaseSkeleton :height="44" fullwidth />
    <BaseSkeleton :height="56" fullwidth />
    <BaseSkeleton :height="56" fullwidth />
  </FlowCard>
</template>
